'use client'
import { atomWithReset } from 'jotai/utils'
import { useTranslations } from 'next-intl'
import { useFormContext } from 'react-hook-form'

import { maxLength } from '@/utils'

import { RhcField } from '../../components/RhcField'
import { COMPANY_FIELDS_MAX_LENGTH, TAboutFormFields } from './aboutFormModel'

export const aboutCompanyNameAtom = atomWithReset<string | undefined>('')
export const aboutProfessionAtom = atomWithReset<string | undefined>('')

export const CompanyAboutSubSection = () => {
	const t = useTranslations()

	const form = useFormContext<TAboutFormFields>()

	return (
		<div className="flex flex-col gap-4 tablet:flex-row tablet:gap-8">
			<RhcField
				type="text"
				form={form}
				path="company.companyName"
				atom={aboutCompanyNameAtom}
				fieldName="company_name"
				fieldGroup="company_details"
				className="grow"
				onChangeTransform={(event) =>
					maxLength(COMPANY_FIELDS_MAX_LENGTH)(event)
				}
				label={t(
					'generator__content_form_section__about__company_section__name',
				)}
				placeholder={t(
					'generator__content_form_section__about__company_section__name__placeholder',
				)}
			/>
			<RhcField
				type="text"
				form={form}
				path="company.profession"
				atom={aboutProfessionAtom}
				fieldName="profession"
				fieldGroup="company_details"
				className="grow"
				onChangeTransform={(event) =>
					maxLength(COMPANY_FIELDS_MAX_LENGTH)(event)
				}
				label={t(
					'generator__content_form_section__about__company_section__profession',
				)}
				placeholder={t(
					'generator__content_form_section__about__company_section__profession__placeholder',
				)}
			/>
		</div>
	)
}
